/* @flow */

export const allTopicsLimit = 10;
export const allTopicsThreshold = 250;

export const marketSponsorInterstitialIndexes = [3, 6, 9];

export const highlightsFilter = 'highlight';
export const justCreatedFilter = 'new';
export const attendeesFilter = 'position';
export const companyFilter = 'company';

export const bookmarkedParam = 'bookmarked';

export const slackNotificationTimemout = 10000; // miliseconds
export const favoriteNotificationTimeout = 4000; // miliseconds

export const orderingParam = 'ordering';

export const recommendedSortingOrder = '';
export const newestSortingOrder = '-date_created';
export const mostViewedSortingOrder = '-statistics__views_count';
export const upcomingSortingOrder = 'timing';

export const kindFilterParam = 'kind';
export const languageFilterParam = 'language';
export const upcomingFilterParam = 'status';

export const offerKindFilter = 'offer';
export const groupKindFilter = 'group';
